export const ConfigTypes = {
    LANG_CHANGE : 'CONFIG_LANG_CHANGE',
    JUMP_TO_TAB : 'CONFIG_JUMP_TO_TAB',
    VIEW_CHANCELOG : 'CONFIG_VIEW_CHANCELOG',
    SET_TABLE_ID : 'CONFIG_SET_TABLE_ID',
};